/*

Close button
Made by LP
-> A close button
-> Active

*/

import React from 'react';
import './CloseButton.scss'
import { BsXLg } from 'react-icons/bs'

interface CloseButtonProps {
    onClose: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClose }) => (
    <button className="close-button" onClick={onClose}>
        <BsXLg/>
    </button>
);

export default CloseButton;

